import * as React from 'react'
import { Form } from 'antd'
import { showError } from 'helpers/errors'
import { createSetFilterValue } from 'helpers/filters'
import { stopEvent } from 'helpers/events'
import { t } from 'helpers/i18n'
import { createDropdownRender, createSearchSuppliers } from 'helpers/formViews'
import Select, { Option, getOptionProps } from 'elements/Select'
import SelectProductCategories from 'containers/ProductCategories/Select'
import DateRangePicker from 'elements/DateRangePicker'
import { Row, Col } from 'elements/Grid'

const transactionTypes = {
  0: 'purchase',
  1: 'receiving',
  2: 'issue',
  3: 'inventoryAdjustment',
  4: 'inventoryTransfer',
}

class Filter extends React.Component {
  constructor(props) {
    super(props)

    this.setFilterValue = createSetFilterValue(this)
    this.searchSuppliers = createSearchSuppliers(this)
  }

  componentDidMount() {
    const { locationGroupIds, locationIds, userGroupIds, productCategoryIds, supplierIds } = this.props.filterDto

    Promise.all([
      this.props.getUserGroups(),
      this.props.getUsers({ userGroupIds, vending: 'All' }),
      this.props.getLocationGroups(),
      this.props.getLocations({ locationGroupIds, locationIds }),
      this.props.getProductCategories({ productCategoryIds }),
      this.props.getSuppliers(supplierIds ? { supplierIds } : undefined),
      this.props.customer.moduleSettings.enableOverstockInventory
        ? this.props.getOverstockLocations({ locationGroupIds })
        : Promise.resolve(null),
    ]).catch((error) => showError({ error }))
  }

  render() {
    const { filterDto = {}, suppliers } = this.props

    return (
      <Form layout="vertical" colon={false} onSubmit={stopEvent}>
        <Row>
          <Col fourth>
            <DateRangePicker filterDto={filterDto} setFilterValue={this.setFilterValue} />
          </Col>
          <Col fourth>
            <Form.Item label={t('locationGroup')}>
              <Select
                onChange={(values) => this.setFilterValue('locationGroupIds', values)}
                placeholder={t('all')}
                value={filterDto.locationGroupIds}
                mode="multiple"
              >
                {(this.props.locationGroups ?? []).map((each) => (
                  <Option key={each.id} value={each.id}>
                    <span {...getOptionProps(each)}>{each.displayName}</span>
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label={t('location')}>
              <Select
                onChange={(value) => this.setFilterValue('locationIds', value)}
                mode="multiple"
                placeholder={t('all')}
                value={filterDto.locationIds}
              >
                {(this.props.locations ?? []).map((each) => (
                  <Option key={each.id} value={each.id}>
                    <span {...getOptionProps(each)}>{each.displayName}</span>
                  </Option>
                ))}
              </Select>
            </Form.Item>
            {this.props.customer.moduleSettings.enableOverstockInventory ? (
              <Form.Item label={t('overstockLocation')}>
                <Select
                  onChange={(value) => this.setFilterValue('overstockLocationIds', value)}
                  mode="multiple"
                  placeholder={t('all')}
                  value={filterDto.overstockLocationIds}
                >
                  {(this.props.overstockLocations ?? []).map((each) => (
                    <Option key={each.id} value={each.id}>
                      <span {...getOptionProps(each)}>{each.name}</span>
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            ) : null}
          </Col>
          <Col fourth>
            <Form.Item label={t('users')}>
              <Select
                onChange={(value) => this.setFilterValue('userNames', value)}
                mode="multiple"
                placeholder={t('all')}
                value={filterDto.userNames}
                allowClear
              >
                {(this.props.users ?? []).map((each) => (
                  <Option key={each.userName} value={each.userName}>
                    <span {...getOptionProps(each)}>{each.displayName}</span>
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label={t('productCategory')}>
              <SelectProductCategories
                value={filterDto.productCategoryIds}
                placeholder={t('all')}
                onChange={(value) => this.setFilterValue('productCategoryIds', value)}
                dataSource={this.props.productCategories ?? []}
              />
            </Form.Item>
          </Col>
          <Col fourth>
            <Form.Item label={t('supplier')}>
              <Select
                onChange={(value) => this.setFilterValue('supplierIds', value)}
                mode="multiple"
                placeholder={t('all')}
                value={filterDto.supplierIds}
                dropdownRender={createDropdownRender(suppliers)}
                onSearch={this.searchSuppliers}
                showSearch
              >
                {(suppliers?.items ?? []).map((each) => (
                  <Option key={each.id} value={each.id}>
                    <span {...getOptionProps(each)}>{each.displayName ?? each.name}</span>
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label={t('transactionType')}>
              <Select
                onChange={(value) => this.setFilterValue('transactionTypes', value)}
                mode="multiple"
                placeholder={t('all')}
                value={filterDto.transactionTypes}
              >
                {Object.entries(transactionTypes).map(([key, value]) => (
                  <Option key={key} value={key}>
                    {t(value)}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  }
}

export default Form.create()(Filter)
